import React, { useEffect } from "react";
import { useUser } from "services/auth";

import {
  LdButton,
  LdHeader,
  LdTypo,
  LdIcon,
} from "@emdgroup-liquid/liquid/dist/react";
const Header = () => {
  const { info, logout, login, authHeader } = useUser();
  useEffect(() => {
    if (authHeader?.Authorization !== undefined)
      sessionStorage.setItem("accessToken", authHeader?.Authorization);
  }, [authHeader]);
  return (
    <LdHeader>
      <LdTypo>
        <b className="font-black">Team-o-Meter</b>
      </LdTypo>
      {info !== undefined ? (
        <LdButton onClick={logout} mode="secondary" slot="end" type="button">
          <LdIcon name="user" /> Logout
        </LdButton>
      ) : (
        <LdButton onClick={() => login && login()} mode="secondary" slot="end" type="button">
          <LdIcon name="user" /> Login
        </LdButton>
      )}
    </LdHeader>
  );
};

export default Header;
